<template>
  <el-dialog
    :visible.sync="showExtendParam"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    title="配置扩展参数"
  >
    <el-form ref="form" label-width="100px" :model="form">
      <el-row>
        <el-col>
          <el-form-item label="模板名称">
            <el-select
              class="demo-ruleForm-select"
              v-model="form.template"
              placeholder="请选择模板"
              @input="handleInputChangeTemplate"
            >
              <el-option label="自定义" value="none"></el-option>
              <el-option v-for="item in templateList" :key="item.templateId" :label="item.templateName" :value="item.templateId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="0">
            <el-card v-for="(item, index) in scheduleList" :key="index" class="md-card">
              <el-form-item label="计划名称">{{ item.scheduleName }}</el-form-item>
              <ExtendParam
                ref="extendParam"
                v-model="item.extendParamList"
                :template="form.template"
                style="margin: 12px 20px 0 100px"
              />
            </el-card>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="el-dialog-footer">
      <el-button @click="handleCancel">{{ clockAmountFlag === 1 ? '无参数送审' : '无参数保存'}}</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ExtendParam from '@/components/ExtendParam'

export default {
  components: {
    ExtendParam
  },
  props: {
    templateList: {
      type: Array,
      default: () => []
    },
    schedules: {
      type: Array,
      default: () => []
    },
    clockAmountFlag: {
      type: Number,
      default: 0
    },
    orderId: {
      type: Number,
      default: 0
    },
    scheduleIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showExtendParam: false,
      form: {
        template: ''
      },
      scheduleList: this.schedules
    }
  },
  watch: {
    schedules: {
      handler(val) {
        this.scheduleList = val
      },
      deep: true
    }
  },
  methods: {
    handleInputChangeTemplate(val) {
      this.form.template = val
      if (val === 'none') {
        this.scheduleList = this.scheduleList.map(schedule => {
          schedule.extendParamList = [{
            key: '',
            value: ''
          }]
          return schedule
        })
      } else {
        const templateParam = this.templateList.find(item => item.templateId === val)
        const templateArr = JSON.parse(templateParam.paramsJson)
        this.scheduleList = this.scheduleList.map(schedule => {
          schedule.extendParamList = (templateArr || []).map(item => {
            return {
              key: item.key,
              value: item.defaultValue,
              name: item.name,
              holder: item.holder
            }
          })
          return schedule
        })
      }
    },
    handleSubmit() {
      if (this.form.template === '') {
        this.$message.error('请选择模板')
        return
      }
      const params = {
        orderId: this.orderId,
        clockAmountFlag: this.clockAmountFlag,
        scheduleExtendParamList: this.scheduleList.map(schedule => {
          let extendParams = {
            paramsArray: schedule.extendParamList.map(item => {
              return {
                key: item.key,
                value: item.value
              }
            }),
            template: this.form.template
          }

          return {
            scheduleId: schedule.scheduleId,
            scheduleName: schedule.scheduleName,
            extendParams: JSON.stringify(extendParams)
          }
        })
      }
      this.$service.saveBatchExtendParam(params).then(res => {
        if (res.code === 0) {
          this.$notify({ title: '操作成功', message: '保存成功！', type: 'success' })
          this.showExtendParam = false
          if (this.scheduleIds && this.scheduleIds.length) {
            this.$parent.$parent.$parent.$parent.active = 3
          } else {
            setTimeout(() => {
              this.$emit('refresh', true)
            }, 800)
          }
        }
      })
    },
    handleCancel() {
      // 无参数提交送审
      if (this.clockAmountFlag === 1) {
        const params = {
          ids: this.scheduleList.map(schedule => schedule.scheduleId),
          operateType: 6
        }
        this.$service.operateSchedule(params).then(res => {
          if (res.code === 0) {
            this.$notify({ title: '操作成功', message: '送审成功！', type: 'success' })
          }
        })
      } else {
        this.$notify({ title: '操作成功', message: '已保存计划单为草稿！', type: 'success' })
      }
      this.showExtendParam = false
      if (this.scheduleIds && this.scheduleIds.length) {
        this.$parent.$parent.$parent.$parent.active = 3
      } else {
        setTimeout(() => {
          this.$emit('refresh', true)
        }, 800)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.md-card
  margin-top 20px
.el-dialog-footer
  text-align center
</style>
